export default {
  title: 'טעינת נתונים',
};
